import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-wizard',
  templateUrl: './wizard.component.html',
  styleUrls: ['./wizard.component.scss']
})
export class WizardComponent implements OnInit {

  date = new Date();
  selectedGedcomId: string;
  stepIndex: number = 0;

  constructor() { }

  saveForm(event) {
    console.log(event)
    this.next()
  }

  back() {
    if(this.stepIndex > 0){
      this.stepIndex -= 1
    }
  }

  selectedGedcom(doc_id) {
    // Save selected gedcom document id, to use when redirect to wizard-tree-selection
    this.selectedGedcomId = doc_id;
    this.next()
  }

  next() {
    if(this.stepIndex < 2){
      this.stepIndex += 1
    }
  }

  ngOnInit(): void {
  }

}
